import { formatPercentage, formatPrice } from "../../../utils/helpers";
class CreditAssessedFormatter {
    constructor(loanDetails) {
        this.loanDetails = loanDetails;
    }
    getDownPayment() {
        let formattedDownPayment = formatPrice(this.loanDetails.getDownPaymentSpec().current);
        formattedDownPayment = `${formattedDownPayment} kr`;
        return formattedDownPayment;
    }
    getMonthlyCost() {
        let formattedMonthlyCost = formatPrice(this.loanDetails.getCosts().monthlyCost);
        formattedMonthlyCost = `${formattedMonthlyCost} kr/mån`;
        return formattedMonthlyCost;
    }
    getInterest() {
        let formattedInterest = formatPercentage(this.loanDetails.getInterests().interest);
        formattedInterest = `${formattedInterest} %`;
        return formattedInterest;
    }
    getEffectiveInterest() {
        let formattedEffectiveInterest = formatPercentage(this.loanDetails.getInterests().effectiveInterest);
        formattedEffectiveInterest = `${formattedEffectiveInterest} %`;
        return formattedEffectiveInterest;
    }
    getDuration() {
        const formattedDuration = `${this.loanDetails.getDurationSpec().current} mån`;
        return formattedDuration;
    }
    getCreditAmount() {
        let formattedCreditAmount = formatPrice(this.loanDetails.getCreditAmount());
        formattedCreditAmount = `${formattedCreditAmount} kr`;
        return formattedCreditAmount;
    }
}
export default CreditAssessedFormatter;
